// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* programs */
.lsn-programs-wrapper {
  display: flex;
  flex-direction: column;
  column-gap: 5px;
  margin: 0.4rem 0;
}
.lsn-programs-wrapper .badge-count {
  margin-left: 0.2rem;
  margin-top: -3px;
  font-style: normal;
}
.lsn-programs-wrapper .organization-name {
  font-weight: bolder;
  text-shadow: 0px 0px 0px #000;
}
.lsn-programs-wrapper .lsn-programs-label {
  padding: 0px;
  white-space: pre;
  line-height: normal;
}
.lsn-programs-wrapper .lsn-programs-label i {
  color: var(--main-primary-color);
  width: 1rem;
  text-align: center;
  margin-right: 0.3rem;
}
.lsn-programs-wrapper .lsn-programs-list {
  padding: 0;
  margin: 0 0 0 2rem;
  container: programs-list / inline-size;
}
.lsn-programs-wrapper .lsn-programs-list > li {
  line-height: normal;
  margin: 0.5rem 0 0;
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 0.1rem;
}
.lsn-programs-wrapper .lsn-programs-list > li ul {
  margin: var(--main-border-width) 0 0;
}
.lsn-programs-wrapper .lsn-programs-list > li ul li {
  margin: 0 0 0.5rem;
}
.lsn-programs-wrapper .lsn-programs-list > li ul li:last-child {
  margin-bottom: 0;
}
@container programs-list (min-width: 700px) {
  .lsn-programs-wrapper .lsn-programs-list > li {
    grid-template-columns: auto 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/RequestCard/components/ProgramList.less"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AACF;AALA;EAOI,mBAAA;EACA,gBAAA;EACA,kBAAA;AACJ;AAVA;EAaI,mBAAA;EACA,6BAAA;AAAJ;AAdA;EAkBI,YAAA;EACA,gBAAA;EACA,mBAAA;AADJ;AAnBA;EAuBM,gCAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;AADN;AAzBA;EA+BI,UAAA;EACA,kBAAA;EACA,sCAAA;AAHJ;AA9BA;EAoCM,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,kBAAA;AAHN;AArCA;EA2CQ,oCAAA;AAHR;AAxCA;EA8CU,kBAAA;AAHV;AAKU;EACE,gBAAA;AAHZ;AAYA;EACE;IACE,+BAAA;EAVF;AACF","sourcesContent":["/* programs */\n.lsn-programs-wrapper {\n  display: flex;\n  flex-direction: column;\n  column-gap: 5px;\n  margin: .4rem 0;\n\n  .badge-count {\n    margin-left: .2rem;\n    margin-top: -3px;\n    font-style: normal;\n  }\n\n  .organization-name {\n    font-weight: bolder;\n    text-shadow: 0px 0px 0px #000;\n  }\n\n  .lsn-programs-label {\n    padding: 0px;\n    white-space: pre;\n    line-height: normal;\n\n    i {\n      color: var(--main-primary-color);\n      width: 1rem;\n      text-align: center;\n      margin-right: .3rem;\n    }\n  }\n\n  .lsn-programs-list {\n    padding: 0;\n    margin: 0 0 0 2rem;\n    container: programs-list / inline-size;\n\n    >li {\n      line-height: normal;\n      margin: 0.5rem 0 0;\n      display: grid;\n      grid-template-columns: 1fr;\n      column-gap: .1rem;\n\n      ul {\n        margin: var(--main-border-width) 0 0;\n\n        li {\n          margin: 0 0 .5rem;\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n      }\n    }\n  }\n\n}\n\n@container programs-list (min-width: 700px) {\n  .lsn-programs-wrapper .lsn-programs-list>li {\n    grid-template-columns: auto 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
